// extracted by mini-css-extract-plugin
export default {"container":"CodeVerification_container__nJUV4","verificationCodeTitle":"CodeVerification_verificationCodeTitle__Mdszr","tryAgain":"CodeVerification_tryAgain__aw5e6"};